import { render, staticRenderFns } from "./StartSupportPartnerConversation.vue?vue&type=template&id=13d31ed6&"
import script from "./StartSupportPartnerConversation.vue?vue&type=script&lang=js&"
export * from "./StartSupportPartnerConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports